"use strict";

// throttle
let throttleTimer;

const throttle = (callback, time) => {
  if (throttleTimer) return;
  throttleTimer = true;
  setTimeout(() => {
    callback();
    throttleTimer = false;
  }, time);
};

// detect passive event listener support
let supportsPassive = false;

try {
  let opts = Object.defineProperty({}, "passive", {
    get: function () {
      supportsPassive = true;
    },
  });
  window.addEventListener("testPassive", null, opts);
  window.removeEventListener("testPassive", null, opts);
} catch (e) {}

// update header classes bases on scroll
let lastScrollTop;
let body = document.querySelector("body");

const updateHeader = () => {
  let st = window.pageYOffset || document.documentElement.scrollTop;
  if (st > lastScrollTop) {
    body.classList.add("h-has-scrolled-down");
    st > 200 ? body.classList.add("h-hides-header") : false;
  } else {
    body.classList.remove("h-hides-header");
    st === 0 ? body.classList.remove("h-has-scrolled-down") : false;
  }
  lastScrollTop = st <= 0 ? 0 : st;
};

// listen to passive scroll event, throttled
document.addEventListener(
  "scroll",
  () => {
    throttle(updateHeader, 250);
  },
  supportsPassive ? { passive: true } : false
);
